export interface CohortComparisonSource {
  cohort_value: string;
  counterpart_label?: string;
  headline: string;
  cards: { label: string; value: string; subvalue?: string }[];
  table: {
    theme: string;
    cohort_share: number;
    non_cohort_share: number;
    share_index: number;
    cohort_negative_rate: number;
    non_cohort_negative_rate: number;
    negative_rate_index: number;
  }[];
}

export interface CohortComparisonRow {
  theme: string;
  cohortLabel: string;
  counterpartLabel: string;
  cohortShare: number;
  counterpartShare: number;
  cohortNegativity: number;
  counterpartNegativity: number;
  shareDelta: number;
  negativityDelta: number;
  shareIndex: number;
  negativityIndex: number;
  difference: number;
}

export function buildCohortComparisonRows(block: CohortComparisonSource): CohortComparisonRow[] {
  const counterpartLabel = block.counterpart_label ?? "All other observed members";
  return block.table.map((row) => {
    const shareDelta = row.cohort_share - row.non_cohort_share;
    const negativityDelta = row.cohort_negative_rate - row.non_cohort_negative_rate;
    return {
      theme: row.theme,
      cohortLabel: block.cohort_value,
      counterpartLabel,
      cohortShare: row.cohort_share,
      counterpartShare: row.non_cohort_share,
      cohortNegativity: row.cohort_negative_rate,
      counterpartNegativity: row.non_cohort_negative_rate,
      shareDelta,
      negativityDelta,
      shareIndex: row.share_index,
      negativityIndex: row.negative_rate_index,
      difference: Math.max(Math.abs(shareDelta), Math.abs(negativityDelta)),
    };
  }).sort((left, right) => right.difference - left.difference || left.theme.localeCompare(right.theme));
}

export function sortCohortComparisonRows(rows: CohortComparisonRow[], metric: "share" | "negativity") {
  const index = (row: CohortComparisonRow) => metric === "share" ? row.shareIndex : row.negativityIndex;
  return [...rows].sort((left, right) => index(right) - index(left) || left.theme.localeCompare(right.theme));
}
